import { RIADashboardPage } from './RIADashboardPage';

export default RIADashboardPage;
